var exports = {
  "kL": "xfd349460--51b04d--container",
  "nV": "xfd349460--51b04d--gallery",
  "_8": "xfd349460--51b04d--img",
  "hJ": "xfd349460--51b04d--counter",
  "h_": "xfd349460--51b04d--description",
  "DD": "xfd349460--51b04d--title",
};

module.exports = exports;
